export function minutesToHoursMinutes(minutes?: number | null) {
  if (!minutes) return { hours: 0, minutes: 0 }
  return { hours: Math.floor(minutes / 60), minutes: minutes % 60 }
}
